<h2 mat-dialog-title>Gruppe bearbeiten</h2>
<div mat-dialog-content class="gruppe-edit-content">
    <p class="kunde-label">{{ gruppe.kunde }}</p>

    <mat-form-field class="full-width">
        <mat-label>Gruppenname</mat-label>
        <input matInput type="text" [formControl]="nameCtrl" />
    </mat-form-field>

    <div class="field-grid">
        <kiene-autocomplete
            class="field-cell"
            [class.span-full]="!KieneUtils.isApiOne(client?.kaelbermast)"
            [kieneObject]="standort"
            [genericApiUrl]="'gruppe/read_stall.php'"
            [params]="standortParams"
            [placeholder]="'Standort'"
            [focus]="false"
            [displayFields]="['stall', 'sgs_nummer']"
            separator=", "
            [showClear]="false"
            [emitFreeText]="true"
            (elementSelected)="setStandort($event)"
        >
        </kiene-autocomplete>

        <mat-form-field *ngIf="KieneUtils.isApiOne(client?.kaelbermast)" class="field-cell">
            <mat-label>Aufstalleinheit</mat-label>
            <div class="aufstalleinheit-row">
                <input
                    class="ae-input"
                    matInput
                    type="number"
                    min="1"
                    max="99"
                    maxlength="2"
                    [formControl]="aufstalleinheitJahrCtrl"
                />
                <span class="ae-sep">- AE -</span>
                <input class="ae-input ae-nr" matInput type="number" [formControl]="aufstalleinheitNummerCtrl" />
            </div>
        </mat-form-field>
    </div>

    <div class="field-grid">
        <mat-form-field class="field-cell">
            <mat-label>Einstalldatum von</mat-label>
            <input
                matInput
                [matDatepicker]="einstalldatum_von"
                [formControl]="einstalldatumVonCtrl"
                [readonly]="true"
            />
            <mat-datepicker-toggle matSuffix [for]="einstalldatum_von"></mat-datepicker-toggle>
            <mat-datepicker #einstalldatum_von></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-cell">
            <mat-label>Einstalldatum bis</mat-label>
            <input
                matInput
                [matDatepicker]="einstalldatum_bis"
                [formControl]="einstalldatumBisCtrl"
                [readonly]="true"
            />
            <mat-datepicker-toggle matSuffix [for]="einstalldatum_bis"></mat-datepicker-toggle>
            <mat-datepicker #einstalldatum_bis></mat-datepicker>
        </mat-form-field>
    </div>

    <div
        *ngIf="
            KieneUtils.isApiZero(client?.tierbewegung_melden) ||
            (KieneUtils.isApiOne(client?.tierbewegung_melden) &&
                (KieneUtils.isApiZero(client?.ohrmarke) || anzahlTiereOhrmarke < 1))
        "
        class="field-grid"
    >
        <mat-form-field class="field-cell">
            <mat-label>Anzahl Tiere</mat-label>
            <input matInput type="number" maxlength="15" [formControl]="anzahlTiereCtrl" />
        </mat-form-field>
        <mat-form-field class="field-cell">
            <mat-label>Alter bei Einstallung (Tage)</mat-label>
            <input matInput type="number" maxlength="15" [formControl]="alterEinstallungCtrl" />
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()">Speichern</button>
</div>
